import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import assignedCandidateList from "../../assets/images/reportImageOne.png";
import mailIcon from "../../assets/images/MailIconViolet.png";
import TopNavbar from "../top-navbar/TopNav";
import { CiSearch } from "react-icons/ci";
import { FaEye } from "react-icons/fa";

import ReportPage from "../ClientModule/Report";
import '../../styles/employee/assigned-candidates.css';
import { toast } from "react-toastify";
import { getAssignedCandidatesInfo, updateCandidateStatus } from "../../services/employee/api";
import { useParams } from "react-router-dom";


const EyeIcon = () => <span className="material-icons"></span>;
const MailIcon = () => <span className="mail-icon-purple">✉️</span>;

const AssignedCandidatesList = () => {
  const { status } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem('bgc_token');
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc'
  });

  const fetchCandidates = async () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("bgc_token");
    if (!token) {
      setError("Authentication token not found. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const response = await getAssignedCandidatesInfo(status);

      if (response.data && response.data.data && response.data.data.candidateDTOList) {
        const mappedCandidates = response.data.data.candidateDTOList
          .map((candidate) => ({
            id: candidate.candidateid,
            uniqueId: candidate.candidateid,
            name: candidate.name,
            email: candidate.email,
            status: candidate.bgcStatus || "Unknown",
            statusResponse: candidate.statusResponse || {},
            uanCheckStatus: candidate.uanCheckStatus,
            criminalCheckStatus: candidate.criminalCheckStatus,
          }))
          .sort((a, b) => {
            const numA = parseInt(a.id.replace(/\D/g, ""), 10);
            const numB = parseInt(b.id.replace(/\D/g, ""), 10);
            return numB - numA;
          });
        setCandidates(mappedCandidates);
      } else {
        setCandidates([]);
      }
    } catch (err) {

      if (err.response?.status === 404) {
        // Treat 404 as "no records found"
        setCandidates([]);
        setError(null); // clear error so UI shows "No candidates found."
      } else {
        setError(
          err.response?.data?.message ||
          "Something went wrong while loading candidates."
        );
      }
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchCandidates();
  }, []);

  const getStatusClassName = (status) => {
    switch (status) {
      case "Work in Progress":
        return "status-in-progress";
      case "Completed":
        return "status-bgc-completed";
      case "Verified":
        return "status-bgc-verified";
      case "Not Started":
        return "status-not-started";
      case "Pending":
        return "status-pending";
      default:
        return "";
    }
  };

  const getStatusClass = (status) => {
    if (!status) return "assigned-status-default";

    const normalized = status.toLowerCase();

    if (
      normalized.includes("pending") ||
      normalized.includes("expired") ||
      normalized.includes("work in progress")
    ) {
      return "assigned-status-orange";
    }

    if (normalized.includes("verified")) {
      return "assigned-status-blue";
    }

    if (normalized.includes("completed")) {
      return "assigned-status-green";
    }

    return "assigned-status-default";
  };

  const handleMailClick = async (candidateId) => {
    const candidateRequest = {
      "newStatus": "VERIFIED"
    }

    try {
      setLoadingProfile(true);
      const response = await updateCandidateStatus(candidateId, candidateRequest);

      toast.success("Candidate Status updated successfully", {
        autoClose: 3000,
      });
      fetchCandidates();

    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to verify personal background.';

      toast.error(errorMessage, {
        autoClose: 3000,
      });

      setError(errorMessage);
    } finally {
      setLoadingProfile(false);
    }
  };

  const handleStartBGC = (uniqueId) => {
    navigate(`/employee/candidateDetails/${uniqueId}`);
  };

  const handleViewDetails = (uniqueId) => {
    navigate(`/candidate-details/${uniqueId}`, {
      state: {
        heading: 'Candidate Report',
        candidate: uniqueId,
      },
    })
    // navigate(`/employee/candidatereportpage/${uniqueId}`);

  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' };
    });
  };


  const filteredCandidates = React.useMemo(() => {
    let data = candidates.filter((candidate) =>
      Object.values(candidate).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );

    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let valA = a[sortConfig.key] ?? '';
      let valB = b[sortConfig.key] ?? '';

      if (sortConfig.key === 'uniqueId') {
        valA = parseInt(valA.replace(/\D/g, ''), 10);
        valB = parseInt(valB.replace(/\D/g, ''), 10);
      } else {
        valA = valA.toString().toLowerCase();
        valB = valB.toString().toLowerCase();
      }

      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [candidates, searchTerm, sortConfig]);


  const totalPages = Math.ceil(filteredCandidates.length / entriesPerPage);
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredCandidates.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) {
      return <span className="ascend-candidates-sort-icons">▲▼</span>;
    }

    return (
      <span className="ascend-candidates-sort-icons ascend-candidates-sort-active">
        {sortConfig.direction === 'asc' ? '▲' : '▼'}
      </span>
    );
  };



  return (
    <div className="dashboard-app-container">
      <Sidebar />
      <div className="assigned-dashboard-right-panel">
        <TopNavbar />

        <div className="content-area-wrapper">
          {loadingProfile && <div className="centered-message">
            <div className="spinner"></div>
            <div>Sending Mail...</div>
          </div>}
          <main className="assigned-main-content">
            <h2 className="assigne-candidate-list-header">
              Assigned Candidates List
            </h2>
            <section className="assigne-candidate-section">

              <div className="table-controls">


                <label className="entries-label">
                  Entries per page:
                  <select
                    value={entriesPerPage}
                    onChange={handleEntriesPerPageChange}
                    className="show-entries-dropdown"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </label>

                <div className="search-bar-container">

                  <input
                    type="text"
                    placeholder="Search candidates..."
                    className="search-bar-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <span className="search-bar-icon"><CiSearch /></span>
                </div>

              </div>

              {loading ? (
                <p className="loading-message">Loading candidates...</p>
              ) : error ? (
                <p className="error-message">{error}</p>
              ) : (
                <>
                  <div className="assigne-candidate-table-container">
                    <table className="assigne-candidate-table">
                      <thead>
                        <tr>
                          <th className="ascend-candidates-sortable" onClick={() => handleSort('uniqueId')}>
                            Candidate ID  <SortIcon column="uniqueId" />
                          </th>

                          <th className="ascend-candidates-sortable" onClick={() => handleSort('name')}>
                            Name <SortIcon column="name" />
                          </th>

                          <th className="ascend-candidates-sortable" onClick={() => handleSort('email')}>
                            Email<SortIcon column="email" />
                          </th>
                          <th className="ascend-candidates-sortable" onClick={() => handleSort('status')}>
                            Status <SortIcon column="status" />
                          </th>
                          <th>Verification</th>
                          <th style={{ textAlign: "center" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentEntries.length > 0 ? (
                          currentEntries.map((candidate) => (
                            <tr key={candidate.uniqueId}>
                              <td>{candidate.uniqueId}</td>
                              <td>{candidate.name}</td>
                              <td>{candidate.email}</td>
                              <td>
                                {/* <span 
                                                            // className={`status-badge ${getStatusClassName(candidate.status)}`}
                                                            >
                                                                {candidate.status}
                                                            </span> */}

                                <span
                                  className={`assigned-status-badge ${getStatusClass(
                                    candidate.status
                                  )}`}
                                >
                                  {candidate.status}
                                </span>
                              </td>
                              <td>
                                <button
                                  className="start-bgc-button"
                                  onClick={() =>
                                    handleStartBGC(candidate.uniqueId)
                                  }
                                  disabled={
                                    candidate.statusResponse?.personalInfoStatus === "COMPLETED" &&
                                    candidate.statusResponse?.addressInfoStatus === "COMPLETED" &&
                                    candidate.statusResponse?.educationInfoStatus === "COMPLETED" &&
                                    (candidate.statusResponse?.employmentInfoStatus === "COMPLETED" || candidate.statusResponse?.employmentInfoStatus === null) &&
                                    (candidate.uanCheckStatus === "COMPLETED" || candidate.uanCheckStatus === "") &&
                                    candidate.criminalCheckStatus === "COMPLETED"
                                  }
                                >
                                  {candidate.status === "Work in Progress"
                                    ? "In Progress"
                                    : "Start BGC"}
                                </button>
                              </td>
                              <td>
                                <div className="action-buttons-group">
                                  {/* <button
                                                                    className="action-button view-button"
                                                                    onClick={() => handleViewDetails(candidate.uniqueId)}
                                                                    title="View Details"
                                                                >
                                                                    <EyeIcon />
                                                                </button>*/}

                                  <button
                                    type="button"
                                    className="action-button view-button"
                                    style={{ color: '#4D0054' }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleViewDetails(candidate.uniqueId);
                                    }}
                                    title="View Details"
                                  >
                                    <FaEye />
                                  </button>

                                  <button
                                    className="action-button mail-button"
                                    onClick={() =>
                                      handleMailClick(
                                        candidate.id)
                                    }
                                    title="Send Mail"
                                    disabled={
                                      !(
                                        candidate.statusResponse?.personalInfoStatus === "COMPLETED" &&
                                        candidate.statusResponse?.addressInfoStatus === "COMPLETED" &&
                                        candidate.statusResponse?.educationInfoStatus === "COMPLETED" &&
                                        (candidate.statusResponse?.employmentInfoStatus === "COMPLETED" || candidate.statusResponse?.employmentInfoStatus === null) &&
                                        (candidate.uanCheckStatus === "COMPLETED" || candidate.uanCheckStatus === "") &&
                                        candidate.criminalCheckStatus === "COMPLETED" &&
                                        candidate.status === "WORK_IN_PROGRESS")
                                    }                                  >
                                    <img
                                      src={mailIcon}
                                      alt="Send Mail"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        opacity:
                                          candidate.status === "Completed" ||
                                            candidate.status === "Verified"
                                            ? 1
                                            : 1.5,
                                      }}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="no-data">
                              No candidates found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination-container">
                    <div className="pagination-info">
                      Showing{" "}
                      {Math.min(
                        indexOfFirstEntry + 1,
                        filteredCandidates.length
                      )}{" "}
                      to {Math.min(indexOfLastEntry, filteredCandidates.length)}{" "}
                      of {filteredCandidates.length} entries
                    </div>
                    <div className="pagination-buttons">
                      <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                        (page) => (
                          <button
                            key={page}
                            className={`pagination-button ${currentPage === page ? "active" : ""
                              }`}
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </button>
                        )
                      )}
                      <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              )}
            </section>
          </main>
        </div>


      </div>
    </div>
  );
};

// PropTypes are no longer needed as handleViewCandidateDetails is removed
// AssignedCandidatesList.propTypes = {
//     handleViewCandidateDetails: PropTypes.func.isRequired,
// };

export default AssignedCandidatesList;